import "./MultiDuplicateOrdersNotificationDialog.scss";
import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {Observable} from "rxjs";
import {SequenceDuplicateVettingResponse} from "../../types/DuplicateOrdersVettingResponse";
import {MultiDuplicateOrdersNotificationDialogController} from "./MultiDuplicateOrdersNotificationDialogController";

export class MultiDuplicateOrdersNotificationDialog {

    public static id = "multiDuplicateOrdersNotificationDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public open(duplicates: SequenceDuplicateVettingResponse[]): Observable<boolean> {
        const settings: IModalSettings = {
            templateUrl: "app/portfolio/templates/ticket/place-multi-equity-order-wizard/dialog/MultiDuplicateOrdersNotificationDialogTemplate.html",
            controller: MultiDuplicateOrdersNotificationDialogController,
            controllerAs: "ctrl",
            resolve: {
                duplicates: () => duplicates
            },
            backdrop: "static",
            windowClass: "multi-duplicate-orders-notification-dialog"
        };
        const instance = this.$uibModal.open(settings);
        return Observable.fromPromise(instance.result)
                         .catch(() => Observable.of(false));
    }
}
